import { render, staticRenderFns } from "./WholesalerAutocomplete.vue?vue&type=template&id=19c4a61a&scoped=true&"
import script from "./WholesalerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./WholesalerAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./WholesalerAutocomplete.vue?vue&type=style&index=0&id=19c4a61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c4a61a",
  null
  
)

export default component.exports